import Login from '~cp/Authentication/Login/Login.vue'
import Register from '~cp/Authentication/Register/Register.vue'
import SocialConfirm from '~cp/Authentication/Social/SocialConfirm/SocialConfirm.vue'
import ForgotPassword from '~cp/Authentication/ForgotPassword/ForgotPassword'
import NewPassword from '~cp/Authentication/NewPassword/NewPassword'

import i18n from '@/i18n/i18n'

export default [
    {
        path: i18n.locale === 'lt' ? '/prisijungti' : '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/login-admin',
        name: 'AdminAuth',
        component: () => import('~cp/Authentication/Login/LoginAdmin.vue')
    },
    {
        path: i18n.locale === 'lt' ? '/registracija' : '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword
    },
    {
        path: '/reset-password',
        name: 'NewPassword',
        component: NewPassword
    },
    // TODO: fix route if it still will be needed (after clear social connect)
    {
        path: '/connect/social/:token',
        name: 'social-confirm',
        component: SocialConfirm,
        props: true
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/authentication-routes.js